// React
import React, { useState, useRef, useEffect } from "react";

// React Async
import Async from "react-async";

// Components
import { Form } from "react-bootstrap";
import {
  ProgressBar,
  Modal,
  Button,
  Table,
  Row,
  Col,
  Container,
  Badge
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";

// Internal Libs
import { useFormFields } from "../libs/hooksLib";
import AffinityAPI from "../libs/AffinityAPI";
import * as ModelCache from "../libs/ModelCache";
import * as EventifyAPI from "../libs/EventifyAPI";

// CSV
import parse from "csv-parse";

// AWS
import config from "../config";
import { API, Auth } from "aws-amplify";

// Local Storage
import ls from "local-storage";

// UUID
const uuidv4 = require("uuid/v4");

const ListUploaderModal = React.forwardRef((props, ref) => {
  let listid = props.listid;

  const [isLoading, setIsLoading] = useState(false);
  const [uploadButtonTitle, setUploadButtonTitle] = useState("Upload List");
  const [targetListId, setTargetListId] = useState(null);
  const [targetList, setTargetList] = useState({});

  const [fields, handleFieldChange] = useFormFields({
    listName: ""
  });
  const [content, setContent] = useState("");
  const [tableContent, setTableContent] = useState([]);

  // File Handle
  const file = useRef(null);

  const listNameRef = useRef(null);

  // Affinity results
  var emailToAffinityId = {};

  useEffect(() => {
    onLoad();
  }, [listid]);

  async function onLoad() {
    setTargetListId(listid);
    ModelCache.getListForId(
      listid,
      ( (list) => {
        setTargetList(list);
      })
    )
  }

  function handleFileChange(event) {
    var newFile = event.target.files[0];
    if (newFile === null) {
      return;
    }
    file.current = event.target.files[0];
    readSingleFile(file.current);
    // var rando = {};
    // rando.target = {};
    // rando.target.id = fields.listName;
    // rando.target.value = file.current;
    // handleFieldChange(rando)

    if (targetListId != null) {
      const fileNameCleaned = file.current.name
      .replace(".csv", "")
      .replace("_", " ");
      fields.listName = fileNameCleaned;
      if (listNameRef.current != null) {
        listNameRef.current.value = fileNameCleaned;
      }
    }
  }

  function validateForm() {
    return fields.listName.length > 0 && tableContent.length > 0;
  }

  function readSingleFile(e) {
    var file = e;
    if (!file) {
      return;
    }
    var reader = new FileReader();
    reader.onload = function(e) {
      var csvRaw = e.target.result;
      //
      parseCSV(csvRaw);
    };
    reader.readAsText(file);
  }

  // Ok so for this we need to do a few things.
  // 1. We need to POST each person into the database
  // 2. We need to post the enriched List to the database (originating in the tableContents datastructure)
  // 3.
  async function uploadList() {
    var list = {};
    var result;

    if (targetListId != null) {
      list = targetList;
    } else {
      list.name = fields.listName;
      list.listid = uuidv4();
      result = await EventifyAPI.createList(list.listid, list.name);
    }

    var persons = [];
    var notesMap = {};
    var tagList = [];
    var tagToPeopleList = [];
    var headerRow = tableContent.slice(0, 1)[0];
    headerRow.push("Affinity");

    const rowValues = tableContent.slice(1, tableContent.length);
    rowValues.forEach( (row) => {
      var personObject = {};
      personObject["personid"] = uuidv4();
      var headerK = 0;
      var previouslyUsedInviteEmail = null; // here we assume that email should always come first in the column order
      row.richArray.forEach( (datum) => {
        const headerValue = headerRow[headerK];
        const headerValueLowerCase = headerValue.toLowerCase();
        const rawDatum = datum.raw.trim();
        if (headerValueLowerCase === "name") {
          const nameValue = rawDatum === "" ? null : rawDatum;
          if (nameValue != null) {
            personObject[headerValueLowerCase] = nameValue;
          }
        } else if (headerValueLowerCase === "email") {
          const emailValue = rawDatum === "" ? null : rawDatum;
          if (emailValue != null) {
            previouslyUsedInviteEmail = emailValue;
            personObject[headerValueLowerCase] = emailValue;
          }
        } else if (headerValueLowerCase === "comments" || headerValueLowerCase === "notes") {
          const notes = rawDatum === "" ? null : rawDatum;
          if (notes != null) {
            const notesObj = { listid: list.listid, personid: personObject.personid, notes: notes };
            notesMap[personObject.personid] = notesObj;
          }
        } else if (headerValueLowerCase === "tags") {
          const tag = rawDatum === "" ? null : rawDatum;
          if (tag !== null && typeof tag !== "undefined" && tag !== "") {
            const tagObj = { tagId: uuidv4(), raw: tag, stringLowerCase: tag.toLowerCase() };
            tagList.push(tagObj);
            const tagAssociation = { tagId: tagObj.tagId, personid: personObject.personid, listid: list.listid };
            tagToPeopleList.push(tagAssociation);
          }
        }
        headerK++;
      });
      // if (previouslyUsedInviteEmail != null) {
      //   const affinityIdentityData = emailToAffinityId[previouslyUsedInviteEmail];
      //   if (affinityIdentityData != null && affinityIdentityData.doesNotExist === false)  {
      //     const affinityData = affinityIdentityData.foundMatchedPerson;
      //     personObject["affinity"] = affinityData;
      //   }
      // }
      persons.push(personObject);
    });

    var stalePersonIdMap = {};
    for (var k=0; k<persons.length; k++) {
      const person = persons[k];
      stalePersonIdMap[person.personid] = person.personid;
    }

    setUploadButtonTitle("Uploading List... Checking " + persons.length + " contacts... (~15s)");

    persons = await EventifyAPI.person_createMultipleIfNotExist(persons);

    // re-map stale to new
    for (var k=0; k<persons.length; k++) {
      const person = persons[k];
      const stalePersonId = person.stalePersonId;
      for (var q=0; q<tagToPeopleList.length; q++) {
        const tagAssociation = tagToPeopleList[q];
        if (stalePersonId === tagAssociation.personid) {
          tagAssociation.personid = person.personid; // map to valid personid
          tagToPeopleList[q] = tagAssociation;
          break;
        }
      }
    }

    var memberships = [];
    for (var k=0; k<persons.length; k++) {
      const personObject = persons[k];
      const membership = { personid: personObject.personid, listid: list.listid, status: "" };
      memberships.push(membership);
    }

    setUploadButtonTitle("Uploading List... Adding " + persons.length + " contacts to list...  (~10s)");

    result = await EventifyAPI.addMultiplePeopleToList(memberships);

    var notesArray = [];
    for (var k=0; k<persons.length; k++) {
      const personObject = persons[k];
      const note = notesMap[personObject.stalePersonId];
      if (note !== null && typeof note !== "undefined") {
        note.personid = personObject.personid;
        notesArray.push(note);
      }
    }

    setUploadButtonTitle("Uploading List... Last bits... (~10s)");

    result = await EventifyAPI.addNotesToMultiplePersonInList(notesArray);

    result = await EventifyAPI.registerManyTags(tagList, tagToPeopleList);

    return result;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (file.current && file.current.size > config.MAX_ATTACHMENT_SIZE) {
      alert(
        `Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE /
          1000000} MB.`
        );
        return;
      }

      setIsLoading(true);

      try {
        const result = await uploadList();

        window.location.reload();
      } catch (e) {
        alert(e);
        setIsLoading(false);
        setUploadButtonTitle("Upload List");
      }
    }

    async function parseCSV(csvRaw) {
      // manually way of doin that thang, obvi not robust, maybe useful for grabbing header metadata
      // const manuallyParsedCSV = manuallyParseCSV(csvRaw);
      // const headerValues = manuallyParsedCSV.headers;
      // const transformedValueRows = manuallyParsedCSV.rows;

      const parser = parse({
        delimiter: ','
      }, function(err, rows) {
        console.log(err);
        console.log(rows);

        var bodyData = [];

        var found = false;
        var count = 0;
        while (found === false && count < rows.length) {
          const currentRow = rows.slice(count, count + 1)[0];
          var foundNameColumn = false;
          var foundEmailColumn = false;
          var foundPopulatedcolumns = false;
          for (var i = 0; i < currentRow.length; i++) {
            if (currentRow[i].toLowerCase().indexOf("email") !== -1) {
              foundEmailColumn = true;
            }
            if (currentRow[i].toLowerCase().indexOf("name") !== -1) {
              foundNameColumn = true;
            }
            if (foundEmailColumn && foundNameColumn) {
              found = true;
              break;
            }
          }
          if (found) {
            break;
          }
          count++;
        }

        const headerRow = rows.slice(count, count + 1);
        const valueRows = rows.slice(count + 1, rows.length + 1);

        var parsedData = headerRow;
        for (var i = 0; i < valueRows.length; i++) {
          var rowObject = {};
          var row = valueRows[i];
          var identifier = "";
          var richArray = [];
          for (var k = 0; k < row.length; k++) {
            identifier += row[k];
            var rowData = {};
            rowData.raw = row[k].trim();
            rowData.identifier = k.toString() + identifier + row[k];
            richArray.push(rowData);
            rowObject[headerRow[0][k].toLowerCase()] = rowData;
          }
          rowObject.identifier = identifier;
          rowObject.richArray = richArray;
          parsedData.push(rowObject);
        }

        setTableContent(parsedData);
      }
    );
    parser.write(csvRaw);
    parser.end();
  }

  // takes in a transformed person object and attempts to enrich it
  function renderAffinityForPerson(personInfo) {
    const fullName = personInfo.name.raw;
    const nameComponents = fullName.split(" ");
    const firstName = nameComponents[0];
    const lastName = nameComponents.slice(1, nameComponents.length).join(" ");
    const email = personInfo.email.raw;

    // const affinityData = await AffinityAPI.findAffinityMatches(firstName, lastName, email);
    return <a>Affinity Data Result</a>;
  }

  function handleAffinityLinkerResult(result) {
    emailToAffinityId[
      result.foundMatchedPerson.previouslyUsedInviteEmail
    ] = result;
    //
    return (
      <>
      {result.doesNotExist === false ? (
        <Badge variant="info">✔ Matched</Badge>
      ) : (
        <Badge variant="light">Not Found</Badge>
      )}
      </>
    );
  }

  async function javascriptWhatTheHeck(email) {
    return emailToAffinityId[email];
  }

  function checkAffinityIfNeeded(row) {
    return async () => {
      if (emailToAffinityId[row.email.raw] == null) {
        const result = await EventifyAPI.grabAffinityDateForPerson(row.name.raw, row.email.raw);
        return result;
      } else {
        const result = await javascriptWhatTheHeck(row.email.raw);
        return result;
      }
    };
  }

  function renderCSV(csvData) {
    var headerValues = csvData.slice(0, 1);
    const rowValues = csvData.slice(1, csvData.length);

    if (headerValues.length === 1) {
      headerValues = headerValues[0];

    }

    return (
      <>
        <Table responsive>
          <thead>
            <tr>
              <th>#</th>
              {headerValues.map((headerValue, i) => (
                <th key={headerValue}>{headerValue}</th>
              ))}
              <th>Affinity</th>
            </tr>
          </thead>
          <tbody>
          {rowValues.map((row, n) => (
            <tr key={row.identifier}>
              <td key={row.identifier}>{n + 1}</td>
              {row.richArray.map((data, i) => (
                <td key={data.identifier}>{data.raw}</td>
              ))}
              <td key={row.identifier + "_affinitydata"}>
              </td>
            </tr>
          ))}
          </tbody>
        </Table>
      </>
    );
  }

  // <Async promiseFn={checkAffinityIfNeeded(row)}>
  // <Async.Pending>Loading...</Async.Pending>
  // <Async.Fulfilled>
  // {data => <div>{handleAffinityLinkerResult(data)}</div>}
  // </Async.Fulfilled>
  // <Async.Rejected>
  // {error => `Something went wrong: ${error.message}`}
  // </Async.Rejected>
  // </Async>

  return (
    <Modal
      show={props.visible}
      onHide={props.onCancel}
      animation={false}
      size="lg"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Eventify List Uploader</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Row>
                <Col>
                  <Form.Group controlId="listName">
                    <Form.Label>List Name</Form.Label>
                    { targetListId != null
                    ? <Form.Control
                        ref={listNameRef}
                        type="text"
                        value={targetList.name}
                        disabled={true}
                      />
                    : <Form.Control
                        ref={listNameRef}
                        type="text"
                        value={fields.listName}
                        onChange={handleFieldChange}
                      />}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="file">
                    <Form.Label>Choose a CSV</Form.Label>
                    <Form.Control onChange={handleFileChange} type="file" />
                  </Form.Group>
                </Col>
              </Row>
            </Row>
            <Row>{renderCSV(tableContent)}</Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <LoaderButton
            block
            type="submit"
            isLoading={isLoading}
            disabled={!validateForm()}
          >
            {uploadButtonTitle}
          </LoaderButton>
          <Button variant="secondary" onClick={props.onCancel}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
});

export default ListUploaderModal;
